/**
 * Mã lỗi khi tài khoản hạch toán không tồn tại trong danh mục (QLTS)
 */
export default {
    AllNotExistError: "AllNotExistError",
    APartNotExistError: "APartNotExistError"
}